import { render } from "./ResponseExtraPage.vue?vue&type=template&id=12345021"
import script from "./ResponseExtraPage.vue?vue&type=script&lang=js"
export * from "./ResponseExtraPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__